import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    d: "M47.8 10.8l-5.6-8.2c-.4-.4-.8-.6-1.3-.6H7.1c-.5 0-.9.2-1.2.6L.3 10.8c-.2.2-.3.5-.3.8v5.6c0 3.9 3.2 7 7.1 7 2.3 0 4.4-1.1 5.6-2.8 1.3 1.7 3.3 2.8 5.6 2.8s4.4-1.1 5.6-2.8c1.3 1.7 3.3 2.8 5.6 2.8s4.4-1.1 5.6-2.8c1.3 1.7 3.3 2.8 5.6 2.8 3.9 0 7.1-3.1 7.1-7v-5.6c.2-.3.1-.6 0-.8zm-36.4.4c0 .1-.1.3-.1.4v5.6c0 2.3-1.9 4.2-4.2 4.2s-4.2-1.9-4.2-4.2V12l5-7.2h5.5l-2 6.4zm7 10.2c-2.3 0-4.2-1.9-4.2-4.2v-5.4l2.1-7h6.3v12.4c0 2.3-1.9 4.2-4.2 4.2zm15.5-4.2c0 2.3-1.9 4.2-4.2 4.2s-4.2-1.9-4.2-4.2V4.8h6.3l2.1 7v5.4zm11.3 0c0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.2-1.9-4.2-4.2v-5.6c0-.1 0-.3-.1-.4l-1.9-6.4h5.5l5 7.2v5.2zm-2.4 10v16c0 1.5-1.2 2.8-2.8 2.8H8c-1.5 0-2.8-1.2-2.8-2.8v-16c.6.1 1.2.2 1.8.2.3 0 .6 0 .9-.1v15.9h32V27.3c.3 0 .6.1.9.1.8 0 1.4-.1 2-.2zm-5.8-.8v8.9c0 1.7-1.3 3-3 3H14c-1.7 0-3-1.4-3-3v-8.9c.6-.3 1.2-.6 1.7-.9.4.3.8.5 1.3.7v9.1h20v-9.1c.4-.2.9-.5 1.3-.7.5.3 1.1.6 1.7.9z",
    fill: "currentColor"
  })
});